module.exports = __webpack_public_path__ + "static/media/product-detail-layout-button-three.8680ed59.png";